/* Vidéos légères (audit vitesse du 22/10/2026) : les <video data-tk-autoplay preload="none"> ne se téléchargent
   et ne se lancent (muettes, en boucle) qu'à leur arrivée à l'écran ; elles s'arrêtent quand elles en sortent.
   Une vidéo mise en pause par la cliente n'est pas relancée. Chargé par snippets/tk-video-lazy.liquid.
   data-tk-hls : la seule version mp4 fournie est au-dessus de 720p ; on lit la liste HLS de Shopify pour trouver la 720p
   (nommage « X.HD-720p.4.5Mbps.hls.123_.m3u8 » -> « X.HD-720p-4.5Mbps-123.mp4 »), source d'origine gardée si la 720p est introuvable. */
(function () {
  if (window.tkVideoLazy) return;
  window.tkVideoLazy = true;
  function to720(v) {
    var hls = v.getAttribute('data-tk-hls');
    var src = v.querySelector('source');
    if (!hls || !src || !window.fetch) return Promise.resolve();
    v.removeAttribute('data-tk-hls');
    return fetch(hls).then(function (r) { return r.ok ? r.text() : ''; }).then(function (txt) {
      var lines = txt.split(/\r?\n/), best = null, bestH = 0;
      for (var i = 0; i < lines.length; i++) {
        var m = /RESOLUTION=\d+x(\d+)/.exec(lines[i]);
        var h = m ? parseInt(m[1], 10) : 0;
        var name = lines[i + 1] || '';
        var n = /^(.*)\.([A-Z]+-\d+p)\.([\d.]+Mbps)\.hls\.(\d+)_\.m3u8/.exec(name);
        if (h && h <= 720 && h > bestH && n) { best = n[1] + '.' + n[2] + '-' + n[3] + '-' + n[4] + '.mp4'; bestH = h; }
      }
      if (!best) return;
      var url = hls.replace(/[^\/]*$/, best);
      // On vérifie que le fichier 720p existe (requête HEAD, sans corps) avant de remplacer la source.
      return fetch(url, { method: 'HEAD' }).then(function (r) {
        if (!r.ok) return;
        src.setAttribute('src', url);
        v._tkAutoPause = !v.paused;
        v.load();
      });
    }).catch(function () {});
  }
  function play(v) {
    if (v.getAttribute('data-tk-user-paused') === '1') return;
    if (v.hasAttribute('data-tk-hls')) { to720(v).then(function () { if (v._tkVisible) play(v); }); return; }
    v.muted = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function init() {
    var vids = Array.prototype.slice.call(document.querySelectorAll('video[data-tk-autoplay]'));
    if (!vids.length) return;
    vids.forEach(function (v) {
      v.addEventListener('pause', function () {
        if (!v._tkAutoPause && v._tkVisible) v.setAttribute('data-tk-user-paused', '1');
        v._tkAutoPause = false;
      });
      v.addEventListener('play', function () { v.removeAttribute('data-tk-user-paused'); });
    });
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v._tkVisible = true; play(v); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        v._tkVisible = e.isIntersecting;
        if (e.isIntersecting) play(v);
        else if (!v.paused) { v._tkAutoPause = true; v.pause(); }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
